import { ReactNode } from 'react';
import { Tab } from 'semantic-ui-react';
import Categories from './components/categories';
import CategoriesRelations from './components/categoriesRelations';

const CategoriesPage = () => {
    const panes = [getPane('Categories', <Categories />), getPane('Relations', <CategoriesRelations />)];
    return <Tab panes={panes} />;
};

export default CategoriesPage;

function getPane(name: string, content: ReactNode) {
    return {
        menuItem: name,
        render: () => <Tab.Pane className="companyRootTab">{content}</Tab.Pane>,
    };
}
